import type { z } from "@hono/zod-openapi";
import { onDriverRefs } from "../../refs";

/**
 * The driver who answered the route assignment.
 *
 * No vehicle: the answer is a person's, and which unit they end up on is the assignment stream's to say.
 */
export const routeAssignmentEventRefs = { ...onDriverRefs };

export type RouteAssignmentEventRefs = z.infer<z.ZodObject<typeof routeAssignmentEventRefs>>;
